import { useAuth } from "m2m-components/storage/useM2mAuth"
import { Button, Typography, useAlert, UserTextRenderer } from "matsuri-ui"
import { useMemo } from "react"
import { css } from "@emotion/react"
import { useClipboardCopy } from "matsuri-hooks"
import { InfoSection } from "../InfoSection"
import { extractWifiInfo } from "@/model/bigQueryInfo"
import { useListingBigQueryTable } from "@/hooks/useListingBigQueryTable"
import { useTranslation } from "@/hooks/useTranslation"

export const RoomWifiInfo = ({ operationId }: { operationId: string }) => {
    const { token } = useAuth()
    const { data: listingBigQueryTable } = useListingBigQueryTable(
        token,
        operationId
    )

    const wifiInfo = useMemo(
        () => extractWifiInfo(listingBigQueryTable?.rows ?? []),
        [listingBigQueryTable?.rows]
    )

    const { t } = useTranslation()
    const { addAlert } = useAlert()

    const clipboardCopy = useClipboardCopy({
        onSuccess: () => {
            addAlert(t("パスワードをコピーしました"), {
                duration: 3000
            })
        }
    })

    return (
        <InfoSection>
            <Typography variant="h4" bolder>
                {t("Wi-Fi情報")}
            </Typography>
            <div>
                <Typography bolder>SSID</Typography>
                {wifiInfo ? (
                    <Typography>
                        <UserTextRenderer>{wifiInfo.ssid}</UserTextRenderer>
                    </Typography>
                ) : (
                    <Typography>{t("Wi-Fi情報がありません")}</Typography>
                )}
            </div>
            {wifiInfo ? (
                <div>
                    <Typography bolder>{t("パスワード")}</Typography>
                    <div
                        css={css`
                            display: flex;
                            gap: 8px;
                            align-items: center;
                        `}
                    >
                        <Typography>
                            <UserTextRenderer>
                                {wifiInfo.password}
                            </UserTextRenderer>
                        </Typography>
                        <Button
                            color="primary"
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                clipboardCopy(wifiInfo.password)
                            }}
                        >
                            {t("コピー")}
                        </Button>
                    </div>
                </div>
            ) : null}
        </InfoSection>
    )
}
